import React from 'react';
import {
    TimeActivityIcon,
    AmountsOwedIcon,
    DailyTotalsIcon,
    ActivitynIcon,
    TimesheetIcon,
    InsightsnIcon,
    InvoicesIcon,
    CalendarbIcon,
    TimeOffIcon,
    MapIcon,
    JobSitesIcon,
    PaymentsnIcon,
    AchievementsIcon,
    WorkBreaksnIcon,
    OvertimeIcon,
} from '../../../icons'; // adjust path accordingly

const iconStyle = { fontSize: 40, color: '#1976d2' };

export const enableDisableFeaturesData = [
    {
        icon: <TimeActivityIcon style={iconStyle} />,
        title: 'Approve timesheets',
        description: 'View hours worked, activity %, and screenshots per project or task.',
        status: 'enabled',
    },
    {
        icon: <AmountsOwedIcon style={iconStyle} />,
        title: 'Monitor desktop activity',
        description: 'See how much each team member is owed based on tracked work.',
        status: 'disabled',
    },
    {
        icon: <DailyTotalsIcon style={iconStyle} />,
        title: 'Pay team',
        description: 'Review time and activity trends for each team member.',
        status: 'enabled',
    },
    {
        icon: <TimeActivityIcon style={iconStyle} />,
        title: 'Invoices',
        description: 'View hours worked, activity %, and screenshots per project or task.',
        status: 'enabled',
    },
    {
        icon: <AmountsOwedIcon style={iconStyle} />,
        title: 'Work orders & Jobs',
        description: 'See how much each team member is owed based on tracked work.',
        status: 'disabled',
    },
    {
        icon: <DailyTotalsIcon style={iconStyle} />,
        title: 'Track time at job sites',
        description: 'Review time and activity trends for each team member.',
        status: 'enabled',
    },
    {
        icon: <TimeActivityIcon style={iconStyle} />,
        title: 'Schedule shifts',
        description: 'View hours worked, activity %, and screenshots per project or task.',
        status: 'enabled',
    },
    {
        icon: <AmountsOwedIcon style={iconStyle} />,
        title: 'Track time off',
        description: 'See how much each team member is owed based on tracked work.',
        status: 'disabled',
    },
    {
        icon: <DailyTotalsIcon style={iconStyle} />,
        title: 'Achievements',
        description: 'Review time and activity trends for each team member.',
        status: 'enabled',
    },
    {
        icon: <TimeActivityIcon style={iconStyle} />,
        title: 'Teams',
        description: 'View hours worked, activity %, and screenshots per project or task.',
        status: 'enabled',
    },
    {
        icon: <AmountsOwedIcon style={iconStyle} />,
        title: 'Expenses',
        description: 'See how much each team member is owed based on tracked work.',
        status: 'disabled',
    },
    {
        icon: <DailyTotalsIcon style={iconStyle} />,
        title: 'Work breaks',
        description: 'Review time and activity trends for each team member.',
        status: 'enabled',
    },

];
